import BluBlocksButton from "components/buttons/Button"
import styled from "styled-components"

export const Button = styled(BluBlocksButton)`
  &[type="button"] {
    padding: 0;
  }
`
